import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from '../../node_module_clones/recompose';

// Utils
import { getCurrentUserFavoriteBoardsRootId, getFavoriteBoardsSelector } from '../workspace/sidebar/sidebarSelector';
import * as boardService from '../element/board/boardService';
import {
    zoomStateContextConsumer,
    ZoomStateContextProvider,
    zoomStateContextProviderDecorator,
} from '../canvas/zoom/ZoomStateContext';

// Components
import SidebarTop from './SidebarTop';
import SidebarBottom from './SidebarBottom';

// Types
import { GeneralWorkspaceProps } from '../workspace/workspaceTypes';

// Styles
import './Sidebar.scss';

export type SidebarProps = GeneralWorkspaceProps & {
    getContextZoomScale: () => number;
};

const enhance = compose(zoomStateContextProviderDecorator, zoomStateContextConsumer);

const Sidebar = (props: SidebarProps): ReactElement => {
    const dispatch = useDispatch();

    const currentUserFavoriteBoardsRootId = useSelector(getCurrentUserFavoriteBoardsRootId);

    useEffect(() => {
        // Fetch the favorite boards if it hasn't been fetched yet
        dispatch(
            boardService.fetchBoard({
                boardId: currentUserFavoriteBoardsRootId,
                excludeSelf: false,
                loadAncestors: false,
            }),
        );
    }, []);

    const sideBarElements = useSelector(getFavoriteBoardsSelector);

    return (
        <ZoomStateContextProvider zoomScale={1}>
            <div className="SidebarContainer">
                <div className="Sidebar">
                    <SidebarTop
                        currentUserFavoriteBoardsRootId={currentUserFavoriteBoardsRootId}
                        sideBarElements={sideBarElements}
                        {...props}
                    />
                    <SidebarBottom {...props} />
                </div>
            </div>
        </ZoomStateContextProvider>
    );
};

export default enhance(Sidebar);
